// extracted by mini-css-extract-plugin
export default {"jse":"jse__iy23X","withMenu":"withMenu__krYi2"};